var team = {};
module['exports'] = team;
team.creature = require("./creature");
team.name = require("./name");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/team/index.js
 ** module id = 551
 ** module chunks = 0
 **/